<template>
    <div>
                <div class="post-header flex justify-between mb-4">
                    <div class="flex items-center">
                        <profile :avatar="post.author_profile.avatar" :profile="post.author_profile" :subtitle="
                                $moment(post.pub_date).format(
                                    'DD.MM.YYYY'
                                )
                            " />
                    </div>
                    <div v-if="post.author_profile.profileId === USER.profileId" class="flex">
                        <vx-tooltip position="left" :text="$t('edit')">
                            <vs-button @click="editNews(post)" size="small" icon="edit"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip class="ml-2" position="left" :text="$t('delete')">
                            <vs-button @click="deleteNews(post)" color="danger" size="small" icon="delete"></vs-button>
                        </vx-tooltip>
                    </div>
                </div>

                <div>
                    <h4>{{ post.title }}</h4>
                </div>
                <div class="post-content">
                    <p>{{ post.content }}</p>
                </div>
                <div v-if="post.front_image" class="post-media-container mb-2 mt-4">

                    <div class="image relative mt-4" v-if="post.front_image">
                        <figure class="rounded">
                            <picture>
                                <img class="responsive rounded lazyload" style="max-height: 350px; object-fit: contain"
                                    :src="post.front_image.path" alt="user-upload" />
                            </picture>
                        </figure>
                    </div>
                </div>

                <vs-divider></vs-divider>

                <div class="flex justify-between -mt-4">
                    <Comment mode="smile" class="mt-5" :previewMode="true" :clubCommentDelete="isFounder"
                        :commentKey="post.uid" />
                </div>
    </div>
</template>


<script>
    import Profile from "@/widgets/Profile";
    import Comment from "@/widgets/CommentBox/Comment";
    import { mapGetters } from "vuex";

    export default {
        name: 'news-card',
        components: {
            Comment,
            Profile
        },
        computed: {
            ...mapGetters({
                USER: "user/getUser",
            }),
            uid() {
                return this.$route.query.uid;
            },
        },

        data() {
            return {
                filesNews:[],
            }
        },
        props: {
            post: {
                type: Object/Array,
                default: {}
            },
            isFounder: {
                type: Boolean,
                default: false
            }
        },
      
        methods: {
             async editNews(post){
                this.$vs.loading()

                    await this.setFiles([post.front_image]);
                //готовка object
                    this.dataNewNews = {
                        title: post.title,
                        content: post.content,
                        image: post.image,
                        uid: post.uid,
                        // student_club: this.userPosts.uid,
                        type:'news',
                        is_update:true,
                        images:this.filesNews,
                    }
                    //vuex action
                    this.$store.dispatch('studclubs/setNews',this.dataNewNews);

                    this.$emit('openEditPopup',{type:'news'});

                setTimeout(() => {
                    this.$vs.loading.close()
                }, 800);

            },
            async deleteNews(post){
                this.$vs.loading();
                const res = await this.$http.delete(
                    `/student_clubs/news/${ post.uid }?student_club=${ this.uid }`,     
                );
                if (res.status === 204) {
                    this.$vs.notify({
                        title: this.$t("succesful"),
                        color: "primary",
                    });
                }
                this.$vs.loading.close();
            },
            
            setFiles(response) {
                // console.log('response', response)
                this.filesNews = [];
                // Преверяю, на то, чтобы, может прийти ответ с уже записанным в files файл
                this.filesNews = this.filesNews.concat(
                    response.map((item) => {
                        return {
                            ...item,
                            response: item,
                        };
                    })
                );
            },
        },
    }

</script>
